import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { options2 } from 'src/app/Component/exam-management/exam-agencies/course-master-add-edit/config/tiny-mce.config';

@Component({
  selector: 'app-tiny-editor-modal',
  templateUrl: './tiny-editor-modal.component.html',
  styleUrls: ['./tiny-editor-modal.component.css']
})
export class TinyEditorModalComponent implements OnInit {
  public tinyMceOption: Object = options2;
  @Input() description =''
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

   onSave() {
    // return edited value to the parent
    this.activeModal.close(this.description ?? '');
  }
    onCross() {
    this.activeModal.dismiss('cancel');
  }
}
